import { useEffect, useState } from 'react';
import { getLocalStorageUserSuffix } from '~/utils/local-storage.client';

export function useLocalStorageSuffix(): string | null {
  const [localStorageSuffix, setLocalStorageSuffix] = useState<string | null>(
    null
  );

  useEffect(() => {
    const getLocalStorageSuffix = async () => {
      const suffix = await getLocalStorageUserSuffix();

      if (!suffix || localStorageSuffix === suffix) return;

      setLocalStorageSuffix(suffix);
    };

    setTimeout(() => {
      getLocalStorageSuffix();
    });
  }, []);

  return localStorageSuffix;
}
